import { render, staticRenderFns } from "./visit_canada_detail.vue?vue&type=template&id=82a7f344&"
import script from "./visit_canada_detail.vue?vue&type=script&lang=js&"
export * from "./visit_canada_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports